// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","389":"25a976c4","453":"54292a4b","455":"60fa4b3a","977":"83aac2ce"}[chunkId] + ".chunk.js";
};